import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters63 = ({ patternUrl, ...props }: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 555.2 410"
      {...props}
      preserveAspectRatio="none"
    >
      <defs>
        <pattern
          id="shutters63"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <path
        fill="url(#shutters63)"
        d="M526.3 1H.9v409h554.2V1h-28.8zm0 380.2H298.9V369h227.4v12.2zm0-17.1H298.9v-24.4h227.4v24.4zm0-29.3H298.9v-24.4h227.4v24.4zm0-29.3H298.9v-24.4h227.4v24.4zm0-29.2H298.9v-24.4h227.4v24.4zm0-29.3H298.9v-24.4h227.4V247zm0-29.3H298.9v-24.4h227.4v24.4zm0-29.3H298.9V164h227.4v24.4zm0-29.3H298.9v-24.4h227.4v24.4zm0-29.3H298.9v-24.4h227.4v24.4zm0-29.3H298.9V76.2h227.4v24.3zm0-29.3H298.9V46.9h227.4v24.3zm0-29.2H298.9V29.8h227.4V42z"
      />
      <path
        fill="#4d4d4d"
        d="M525.8.5H298.4v.1h-40.9V.5H.4v410h257.2v-.1h40.9v.1h257.2V.5h-29.9zM256.6 87.9H30.2V59.5h226.4v28.4zm0 29.3H30.2V88.8h226.4v28.4zm0 29.3H30.2v-28.4h226.4v28.4zm0 29.3H30.2v-28.4h226.4v28.4zm0 29.2H30.2v-28.4h226.4V205zm0 29.3H30.2V206h226.4v28.3zm0 29.3H30.2v-28.4h226.4v28.4zm0 29.3H30.2v-28.4h226.4v28.4zm0 29.3H30.2v-28.4h226.4v28.4zm0 29.3H30.2v-28.4h226.4v28.4zM30.2 58.6V30.3h226.4v28.3H30.2zm0 322.1v-28.3h226.4v28.3H30.2zM256.6 1.5v27.8H30.2V1.5h226.4zm-227.4 408H1.4V1.5h27.8v408zm227.4 0H30.2v-27.8h226.4v27.8zm21 .1h-20V1.4h20v408.2zm248.2-41.1H299.4v-3.9h226.4v3.9zm0 1v11.2H299.3v-11.2h226.5zm-226.5-5.9v-23.4h226.5v23.4H299.3zm226.5-24.3H299.4v-3.9h226.4v3.9zm-226.5-5V311h226.5v23.4H299.3zM525.8 310H299.4v-4h226.4v4zm-226.5-5v-23.4h226.5V305H299.3zm226.5-24.3H299.4v-3.9h226.4v3.9zm-226.5-4.9v-23.4h226.5v23.4H299.3zm226.5-24.4H299.4v-3.9h226.4v3.9zm-226.5-4.9v-23.4h226.5v23.4H299.3zm226.5-24.4H299.4v-3.9h226.4v3.9zm-226.5-4.9v-23.4h226.5v23.4H299.3zm226.5-24.4H299.4v-3.9h226.4v3.9zm-226.5-4.9v-23.4h226.5v23.4H299.3zm226.5-24.4H299.4v-3.9h226.4v3.9zm-226.5-4.9v-23.4h226.5v23.4H299.3zm226.5-24.4H299.4v-3.9h226.4v3.9zm-226.5-4.9V106h226.5v23.4H299.3zM525.8 105H299.4v-4h226.4v4zm-226.5-5V76.7h226.5V100H299.3zm226.5-24.3H299.4v-3.9h226.4v3.9zm-226.5-5V47.4h226.5v23.4H299.3zm226.5-24.3H299.4v-3.9h226.4v3.9zm-226.5-4.9V30.3h226.5v11.2H299.3zm.1-40h226.4v27.8H299.4V1.5zm-21 408.1V1.4h20v28.9h.1v11.2h-.1v5.9h.1v23.4h-.1v5.9h.1V100h-.1v5.9h.1v23.4h-.1v5.9h.1v23.4h-.1v5.9h.1v23.4h-.1v5.9h.1v23.4h-.1v5.9h.1v23.4h-.1v5.9h.1v23.4h-.1v5.9h.1V305h-.1v5.9h.1v23.4h-.1v5.9h.1v23.4h-.1v5.9h.1v11.2h-.1v28.9h-20zm21-.1v-27.8h226.4v27.8H299.4zm255.2 0h-27.8V1.5h27.8v408z"
        opacity={0.2}
      />
      <g fill="#efefef" stroke="gray" strokeMiterlimit={10}>
        <path
          d="M1.4 64.4H4v38.1H1.4zm0 244.1H4v38.1H1.4zM552.5 64.4h2.6v38.1h-2.6zm0 244.1h2.6v38.1h-2.6z"
          opacity={0.2}
        />
      </g>
      <linearGradient
        id="shutters63__a"
        x1={31.018}
        x2={31.018}
        y1={59.154}
        y2={30.277}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__a)" d="M31.9 30.3h-1.7v28.9z" />
      <linearGradient
        id="shutters63__b"
        x1={7161.29}
        x2={7161.29}
        y1={59.154}
        y2={30.277}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__b)" d="M255 30.3h1.6v28.9z" />
      <linearGradient
        id="shutters63__c"
        x1={31.018}
        x2={31.018}
        y1={88.402}
        y2={59.524}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__c)" d="M31.9 59.5h-1.7v28.9z" />
      <linearGradient
        id="shutters63__d"
        x1={7161.29}
        x2={7161.29}
        y1={88.402}
        y2={59.524}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__d)" d="M255 59.5h1.6v28.9z" />
      <linearGradient
        id="shutters63__e"
        x1={31.018}
        x2={31.018}
        y1={117.689}
        y2={88.811}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__e)" d="M31.9 88.8h-1.7v28.9z" />
      <linearGradient
        id="shutters63__f"
        x1={7161.29}
        x2={7161.29}
        y1={117.689}
        y2={88.811}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__f)" d="M255 88.8h1.6v28.9z" />
      <linearGradient
        id="shutters63__g"
        x1={31.018}
        x2={31.018}
        y1={146.976}
        y2={118.098}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__g)" d="M31.9 118.1h-1.7V147z" />
      <linearGradient
        id="shutters63__h"
        x1={7161.29}
        x2={7161.29}
        y1={146.976}
        y2={118.098}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__h)" d="M255 118.1h1.6V147z" />
      <linearGradient
        id="shutters63__i"
        x1={31.018}
        x2={31.018}
        y1={176.263}
        y2={147.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__i)" d="M31.9 147.4h-1.7v28.9z" />
      <linearGradient
        id="shutters63__j"
        x1={7161.29}
        x2={7161.29}
        y1={176.263}
        y2={147.385}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__j)" d="M255 147.4h1.6v28.9z" />
      <linearGradient
        id="shutters63__k"
        x1={31.018}
        x2={31.018}
        y1={205.55}
        y2={176.672}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__k)" d="M31.9 176.7h-1.7v28.9z" />
      <linearGradient
        id="shutters63__l"
        x1={7161.29}
        x2={7161.29}
        y1={205.55}
        y2={176.672}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__l)" d="M255 176.7h1.6v28.9z" />
      <linearGradient
        id="shutters63__m"
        x1={31.018}
        x2={31.018}
        y1={234.837}
        y2={205.959}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__m)" d="M31.9 206h-1.7v28.8z" />
      <linearGradient
        id="shutters63__n"
        x1={7161.29}
        x2={7161.29}
        y1={234.837}
        y2={205.959}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__n)" d="M255 206h1.6v28.8z" />
      <linearGradient
        id="shutters63__o"
        x1={31.018}
        x2={31.018}
        y1={264.124}
        y2={235.246}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__o)" d="M31.9 235.2h-1.7v28.9z" />
      <linearGradient
        id="shutters63__p"
        x1={7161.29}
        x2={7161.29}
        y1={264.124}
        y2={235.246}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__p)" d="M255 235.2h1.6v28.9z" />
      <linearGradient
        id="shutters63__q"
        x1={31.018}
        x2={31.018}
        y1={293.411}
        y2={264.533}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__q)" d="M31.9 264.5h-1.7v28.9z" />
      <linearGradient
        id="shutters63__r"
        x1={7161.29}
        x2={7161.29}
        y1={293.411}
        y2={264.533}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__r)" d="M255 264.5h1.6v28.9z" />
      <linearGradient
        id="shutters63__s"
        x1={31.018}
        x2={31.018}
        y1={322.7}
        y2={293.822}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__s)" d="M31.9 293.8h-1.7v28.9z" />
      <linearGradient
        id="shutters63__t"
        x1={7161.29}
        x2={7161.29}
        y1={322.7}
        y2={293.822}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__t)" d="M255 293.8h1.6v28.9z" />
      <linearGradient
        id="shutters63__u"
        x1={31.018}
        x2={31.018}
        y1={351.987}
        y2={323.109}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__u)" d="M31.9 323.1h-1.7V352z" />
      <linearGradient
        id="shutters63__v"
        x1={7161.29}
        x2={7161.29}
        y1={351.987}
        y2={323.109}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__v)" d="M255 323.1h1.6V352z" />
      <linearGradient
        id="shutters63__w"
        x1={31.018}
        x2={31.018}
        y1={381.274}
        y2={352.396}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__w)" d="M31.9 352.4h-1.7v28.9z" />
      <linearGradient
        id="shutters63__x"
        x1={7161.29}
        x2={7161.29}
        y1={381.274}
        y2={352.396}
        gradientTransform="matrix(-1 0 0 1 7417.094 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.3} />
      </linearGradient>
      <path fill="url(#shutters63__x)" d="M255 352.4h1.6v28.9z" />
      <g opacity={0.54}>
        <linearGradient
          id="shutters63__y"
          x1={412.604}
          x2={412.604}
          y1={46.886}
          y2={41.956}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__y)" d="M298.9 42h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__z"
          x1={412.604}
          x2={412.604}
          y1={76.174}
          y2={71.243}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__z)" d="M298.9 71.2h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__A"
          x1={412.604}
          x2={412.604}
          y1={105.461}
          y2={100.53}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__A)" d="M298.9 100.5h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__B"
          x1={412.604}
          x2={412.604}
          y1={134.748}
          y2={129.817}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__B)" d="M298.9 129.8h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__C"
          x1={412.604}
          x2={412.604}
          y1={164.035}
          y2={159.104}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__C)" d="M298.9 159.1h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__D"
          x1={412.604}
          x2={412.604}
          y1={193.322}
          y2={188.391}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__D)" d="M298.9 188.4h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__E"
          x1={412.604}
          x2={412.604}
          y1={222.609}
          y2={217.678}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__E)" d="M298.9 217.7h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__F"
          x1={412.604}
          x2={412.604}
          y1={251.896}
          y2={246.965}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__F)" d="M298.9 247h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__G"
          x1={412.604}
          x2={412.604}
          y1={281.184}
          y2={276.253}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__G)" d="M298.9 276.3h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__H"
          x1={412.604}
          x2={412.604}
          y1={310.471}
          y2={305.54}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__H)" d="M298.9 305.5h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__I"
          x1={412.604}
          x2={412.604}
          y1={339.758}
          y2={334.827}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__I)" d="M298.9 334.8h227.4v4.9H298.9z" />
        <linearGradient
          id="shutters63__J"
          x1={412.604}
          x2={412.604}
          y1={369.045}
          y2={364.114}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.372} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <path fill="url(#shutters63__J)" d="M298.9 364.1h227.4v4.9H298.9z" />
      </g>
    </svg>
  );
};
